import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrandSelectionComponent } from './brand-selection/brand-selection.component';
import { LoaderComponent } from './loader/loader.component';
import { ReactiveFormsModule } from '@angular/forms';
import { StoreSelectionComponent } from './store-selection/store-selection.component';


@NgModule({
  declarations: [
    BrandSelectionComponent,
    LoaderComponent,
    StoreSelectionComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
  ],
  exports: [
    BrandSelectionComponent,
    LoaderComponent,
    StoreSelectionComponent,
  ]
})
export class CommonComponentModule { }
